export default __webpack_public_path__ + "static/media/icon-dashboard.c3292e52.svg";